import { useState, useEffect } from "react";
import useSWR from "swr";
import { Radio, Paper, Group, Button, Center, Checkbox, Divider } from "@mantine/core";
import { fetcher } from "../../../../services/fetcher";
import GetYourQuoteBooking from "../GetYourQuoteBooking/GetYourQuoteBooking";
import PriceCard from "../../../issuance/components/PriceCard/PriceCard";
import { errorNotifications } from "../../../../utils/handleNotifications";
import QuoteLink from "../../../issuance/containers/QuoteLink/QuoteLink";
import CreateBooking from "../../pages/CreateBooking/CreateBooking";
import BookingForm from "../BookingForm/BookingForm";
import { scrollToElementWithOffset } from "../../../../utils/scrollToElementWithOffset";

const SingleBookingForm = () => {
  const [issueAs, setIssueAs] = useState("User");
  const [selectedOperator, setSelectedOperator] = useState(null); // Store selected operator
  const [quoteUrl, setQuoteUrl] = useState("");
  const [coverOption, setCoverOption] = useState("");
  const [showQuoteLink, setShowQuoteLink] = useState(false);
  const [bookingFormData, setBookingFormData] = useState({});
  const [makePayment, setMakePayment] = useState(false); // Checkbox state


  const { data: quoteData } = useSWR(quoteUrl ? quoteUrl : null, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
    dedupingInterval: 2000,
    onError: (err) => {
      errorNotifications(err.response.data.message || "An error occurred.");
    },
  });

  const handleUrlReady = (url) => {
    setQuoteUrl(url);
  };

  const getFilteredCovers = (covers, totalPrice, currency) => {
    return Object.keys(covers)
      .filter((coverType) => covers[coverType].length > 0)
      .map((coverType) => ({
        type: coverType,
        price: totalPrice[coverType],
        currency: currency,
      }));
  };

  let filteredCovers = [];
  if (quoteData) {
    filteredCovers = getFilteredCovers(quoteData.covers, quoteData.total_price, quoteData.currency);
  }

  useEffect(() => {
    setBookingFormData((prev) => ({
      ...prev,
      make_payment_or_not: makePayment, 
    }));
  }, [makePayment]);

    useEffect(() => {
      if (quoteData) {
        scrollToElementWithOffset("#singleBooking", 90);
      }
    }, [quoteData]);
    
     useEffect(() => {
      if (coverOption) {
        scrollToElementWithOffset("#generateLink", 90);
      }
    }, [coverOption]);
  
    
  return (
    <div>
      <CreateBooking 
        selectedValue={issueAs} 
        onChange={(e) => setIssueAs(e.target.value)} 
        policyType="single" 
        setSelectedCover={() => {}} 
        selectedOperator={selectedOperator} // Pass selectedOperator
        setSelectedOperator={setSelectedOperator} // Capture selected operator
      />
      
      {(issueAs === "User" || (issueAs === "Operator" && selectedOperator)) && (
        <>
        <GetYourQuoteBooking onUrlReady={handleUrlReady} selectedOperator={selectedOperator} />
          {quoteData && (
            <Paper p={"xl"} my={"lg"} id="singleBooking">
              {filteredCovers.length > 0 ? (
                <>
                  <Radio.Group
                    value={coverOption}
                    onChange={(value) => {
                      setCoverOption(value);
                      // setShowTravelerForm(false);
                      setShowQuoteLink(false);
                    }}
                    name="coverSelection"
                    label="Select your cover price"
                    withAsterisk
                  >
                    <Group mt={"xl"}>
                      {filteredCovers.map((cover, index) => (
                        <Radio key={index} value={cover.type} label={<PriceCard cover={cover} currency={cover.currency} index={index} />} />
                      ))}
                    </Group>
                  </Radio.Group>
                  <Divider mt={"xl"} />
                  <BookingForm 
                    hideFields={["csv_file", "plan_name", "client_or_operator", "payment_status", "payment_receipt", "BookingForm", "submit"]}
                    bookingType="SINGLE"
                    onFormChange={(data) => {
                      setBookingFormData((prev) => ({ ...prev, ...data }));
                    }}
                  />
                  {/* Checkbox for payment */}
                  <div style={{ marginTop: "1rem" }}> 
                    <Checkbox 
                      label="Add Payment Gateway" 
                      checked={makePayment} 
                      onChange={(event) => setMakePayment(event.currentTarget.checked)}
                    />
                  </div>
                  <Divider mt={"xl"} />
                  {coverOption && (
                    <Center mt={"lg"} id="generateLink">
                      <Group mt="md">
                        <Button variant="gradient" px={38} onClick={() => setShowQuoteLink(true)}>Next</Button>
                      </Group>
                    </Center>
                  )}
                </>
              ) : (
                <p>No covers available.</p>
              )}
            </Paper>
          )}

          {quoteData && coverOption && showQuoteLink && (
            <>
              <QuoteLink 
                quoteData={quoteData} 
                coverOption={coverOption} 
                bookingFormData={bookingFormData} 
              />
            </>
          )}

        </>
      )}
    </div>
  );
};

export default SingleBookingForm;